import { GetFormattedNumber } from "../../../../../Helpers/Formatters";
import { EsignerRole } from "../../../../../Common/Constant";
import { getEsignPrefillData, isMissingPhoneOrEmail, setPhoneAndEmail } from "./eSignerFunctions";
import { insurancePolicyTypes } from "../../../../ABLTC/SubComponents/SelectOptions";

const getSecondaryPiInfo = (formState) => {
  const { insuredBasicInfo, retrieveAccount } = formState.pages;
  const isSurvivorshipPolicy = retrieveAccount && retrieveAccount.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP;

  // if owner is PI, don't add new PI signer
  if (!isSurvivorshipPolicy || (isSurvivorshipPolicy && retrieveAccount.secondInsured !== 'Other'))
    return null;

  let emailList = [{
    label: insuredBasicInfo.secondaryInsuredEmail, value: insuredBasicInfo.secondaryInsuredEmail
  }];
  let phoneList = [{
    label: GetFormattedNumber(insuredBasicInfo.secondaryInsuredPhone), value: insuredBasicInfo.secondaryInsuredPhone
  }];

  const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);
  const { prefillAuthentication } = getEsignPrefillData(EsignerRole.PROPOSED_INSURED, formState);

  return {
    firstName: insuredBasicInfo.secondaryInsuredFirstName,
    lastName: insuredBasicInfo.secondaryInsuredLastName,
    email: emailVal,
    phone: phoneVal,
    emailList: emailList,
    phoneList: phoneList,
    missingContact: isMissingPhoneOrEmail(emailList, phoneList),
    role: EsignerRole.PROPOSED_INSURED,
    authentication: prefillAuthentication || '',
  };
}

export default getSecondaryPiInfo;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getSecondaryPiInfo.js